import PngPlayer from "./PngPlayer";

export default PngPlayer;
